import { createAsyncThunk } from '@reduxjs/toolkit';
import myPeeguAxios from '../../../utils/myPeeguAxios';
import { apiHeaders } from '../../../utils/apiConstants';
import { getFriendlyApiError } from '../../../utils/apiErrorMessages';

// Dashboard requests are silent: the reports render their own loading / empty states.
const silentRequest = {
    headers: {
        [apiHeaders.preventDefaultLoader]: true,
        [apiHeaders.preventDefaultToast]: true,
    },
};

export const fetchSchoolWideBaseline = createAsyncThunk(
    'baselineAnalytics/fetchSchoolWide',
    async ({ schoolId, academicYearId, baselineCategory, classRoomId }, { rejectWithValue }) => {
        try {
            const response = await myPeeguAxios.get('/counselor/v1/self-assessment/school', {
                ...silentRequest,
                params: {
                    schoolId,
                    academicYearId,
                    ...(baselineCategory ? { baselineCategory } : {}),
                    ...(classRoomId ? { classRoomId } : {}),
                },
            });
            return response?.data?.data;
        } catch (error) {
            return rejectWithValue(
                getFriendlyApiError(error, 'Could not load school analytics. Please try again.'),
            );
        }
    }
);

export const fetchClassroomBaseline = createAsyncThunk(
    'baselineAnalytics/fetchClassroom',
    async ({ classRoomId, baselineCategory }, { rejectWithValue }) => {
        try {
            const response = await myPeeguAxios.get('/counselor/v1/self-assessment/classroom', {
                ...silentRequest,
                params: { classRoomId, baselineCategory },
            });
            return response?.data?.data;
        } catch (error) {
            return rejectWithValue(
                getFriendlyApiError(error, 'Could not load classroom analytics. Please try again.'),
            );
        }
    }
);

export const fetchStudentClinicalData = createAsyncThunk(
    'baselineAnalytics/fetchStudentClinical',
    async ({ recordId }, { rejectWithValue, signal }) => {
        try {
            const response = await myPeeguAxios.get('/counselor/v1/self-assessment/student', {
                ...silentRequest,
                params: { recordId },
                signal,
            });
            return response?.data?.data;
        } catch (error) {
            // Let aborted requests reject as AbortError so the viewer can ignore them.
            if (signal?.aborted || error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
                throw error;
            }
            return rejectWithValue(
                getFriendlyApiError(error, 'Could not load student assessment data. Please try again.'),
            );
        }
    }
);
